var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
    'd-flex': _vm.type !== 'commissioners',
    'flex-column': _vm.type !== 'commissioners',
    'align-items-center': _vm.type !== 'commissioners',
    'col': _vm.type === 'commissioners'
  }},[_c('div',{staticClass:"d-flex justify-content-center"},[_c('img',{attrs:{"src":_vm.data.imageSrc,"alt":_vm.data.name}})]),_vm._v(" "),_c('p',{staticClass:"avatar-name"},[_vm._v(_vm._s(_vm.data.name))]),_vm._v(" "),_c('p',{staticClass:"avatar-position"},[_vm._v(_vm._s(_vm.data.position))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-effcb3a2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/landing-page/cardAvatarImage.vue
// module id = null
// module chunks = 